export default class ChatViewController {
    static $inject = [ '$scope' ];

    constructor(scope) {
        this._scope = scope;
        this._scope.CHATVIEW = 0;
        this._scope.INVITEDPEOPLE = 1;

        this._scope.switchTab = (tab) => this._switchTab(tab);
        this._scope.switchToChatTab = () => this._switchToChatTab();
        this._scope.switchToInvitedPeopleTab = () => this._switchToInvitedPeopleTab();
    }

    _switchTab(tab) {
        this._scope.selectedTab = tab;
    }

    _switchToChatTab() {
        this._switchTab(this._scope.CHATVIEW);
    }

    _switchToInvitedPeopleTab() {
        this._switchTab(this._scope.INVITEDPEOPLE);
    }
}




// WEBPACK FOOTER //
// ./src/modules/catalog/controllers/ChatViewController.js